import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Typography as T, VerticalTimelineChart } from '@dev/ee-components';
import { convertToLocalTime } from '@dev/ee-tools';
import { EventHistory } from '@dev/ee-api/ee-api-models';

import { useMobile } from '@/services/hooks/useMobile';
import { getEmailsStore } from '@/store/emails/actions';
import { DeliveryLogBadge } from '@/assets/DeliveryLogBadge';

type HeaderLineProps = {
    isMobile?: boolean;
};

const HeaderLine = styled.div<HeaderLineProps>`
    display: ${(props) => (!props.isMobile ? 'flex' : 'block')};
    min-height: 92px;
    padding: 32px 0;
`;

const HeaderTitleWrapper = styled.div`
    width: 170px;
`;

const EventHistoryWrapper = styled.div`
    padding: 36px 0;
`;

const EventHistoryTitleWrapper = styled.div`
    padding-bottom: 35px;
`;

const prepareEventHistoryData = (
    eventHistory: EventHistory[]
): {
    badge: JSX.Element;
    date: string;
    time: string;
}[] => {
    if (!eventHistory) {
        return [];
    }

    return eventHistory.map((event, index) => {
        const date = convertToLocalTime(event.Date, 'L');
        const time = convertToLocalTime(event.Date, 'LT');

        return {
            badge: <DeliveryLogBadge status={event.Status} id={index} />,
            date,
            time,
        };
    });
};

const EventHistoryChart = (): JSX.Element => {
    const { t } = useTranslation();
    const isMobile = useMobile();

    const { email } = useSelector(getEmailsStore);

    return isMobile ? (
        <EventHistoryWrapper>
            <EventHistoryTitleWrapper>
                <T variant="body2">{t('eventhistory')}</T>
            </EventHistoryTitleWrapper>
            <div>
                <VerticalTimelineChart
                    buttonText={t('expandall')}
                    data={prepareEventHistoryData(email?.EventHistory)}
                    componentWrapperWidth={315}
                />
            </div>
        </EventHistoryWrapper>
    ) : (
        <HeaderLine>
            <HeaderTitleWrapper>
                <T variant="body2">{t('eventhistory')}</T>
            </HeaderTitleWrapper>
            <div>
                <VerticalTimelineChart
                    buttonText={t('expandall')}
                    data={prepareEventHistoryData(email?.EventHistory)}
                    componentWrapperWidth={315}
                />
            </div>
        </HeaderLine>
    );
};

export default EventHistoryChart;
